import React, {Component, Fragment} from 'react';
import {withRouter} from "react-router";
/* styled-component imports */
// import styled from 'styled-components'
// import {Input} from "reakit";
import {Box, Flex, Text} from 'rebass';
import {Action, Fab} from 'react-tiny-fab';
/* custom styled-components */
import '../../resources/css/fab.css';
import {Content, DesktopBox, MobileBox, MobileHeader, PositionBox, Toolbar} from "../../components/Base";
import {PageTitle} from "../../components/Base/Text";
import UserList from '../../components/UserList'
import {ResumeCheckin} from "../../components/Cards"; 
import ApplyFilter from '../../components/Search/ApplyFilters'
import {ColumnIcon, GridIcon} from "../../components/Base/Icons";
import Loading from '../../components/Base/Loading'
import FilterDropdown from '../../components/Search/FilterDropdown'
import ConfirmCheckIn from '../../components/Modals/ConfirmCheckIn'
import Checkin from './Checkin'
import WavePopup from '../../components/Wave/WavePopup'
/* App components */
import SearchInput from '../../components/Forms/SearchInput'
import StudentSummary from '../../components/StudentSummary'
import {AutoFocusInside} from "react-focus-lock";
import MdAdd from 'react-ionicons/lib/MdAdd'
import { Check, SidebarBox, SidebarWrapper, Chat} from "./styles";
import {filterStudentsByName, returnFilterString} from "../../utils";
import { uniq } from 'lodash-es';

import ConfirmDelete from '../../components/Modals/ConfirmDelete';

class Search extends Component {

	state = {
		columnView: false,
		detailsView: false,
		currentStudent: null,
		leaves: [],
		searchTerm: '',
		newLeaves: [],
		pendingLeaves: [],
		searchResult: [],
		currentLeaves: null,
		checkin: false,
		openRecentCheckin: false,
		recentCheckin: null,
		wave: false,
		updated: false,
		updating: false,
		showWaveHistory: false,
		toggleConfirmCheckIn: false,
		isCheckin: true,
		draftCheckIn: [],
		isLoading: false,
		rosters: [],
		confirmDelete: false,
		deleteRosterData: {},
		locationSearch: '',
		newCheckinRosterFilter: []
	};

	componentDidMount() {
		this.fetchRecentCheckin();
		this.fetchRosters();
		this.fetchSchoolData();
		// const {students} = this.props;
		// console.log(students.length)
		// DO NOT UNCOMMENT THIS UNLESS YOU ARE UPDATING STUDENT FIELDS
		// this.updateStudentFields()
	}

	fetchSchoolData = () => {
		const { school } = this.props;
		//let locationList = [];
		//let locationMap = {};
		let schoolId = localStorage.getItem('school');
		try {
			if (schoolId) {
				/**
				let schoolRef = await this.props.firebase.school(schoolId);
				let locationsRef = await schoolRef.collection('locations').get();
				locationsRef.docs.forEach(doc => locationList.push({id: doc.id, ...doc.data()}));
				locationsRef.docs.forEach(doc => locationMap[doc.id] = doc.data());
				locationList.sort((locPre, locNxt) => {
					var namePre = locPre.name.toUpperCase(); // ignore upper and lowercase
					var nameNxt = locNxt.name.toUpperCase(); // ignore upper and lowercase
					if (namePre < nameNxt) {
					return -1;
					}
					if (namePre > nameNxt) {
					return 1;
					}
					// names must be equal
					return 0;
				});
				*/
				const locations = {
					list: school.locations.list,
					map: school.locations.map
				};
				const leaves = {
					locations: locations
				};
				this.setState({locationSearch: leaves});
			}
		} catch(e) {	
		}
	}

	fetchRosters = async () => {
		const { profile } = this.props;
		let result = [];
		let myRosters = await this.props.firebase.rosters().where('creator_uid', '==', profile.id).get();
	    myRosters.forEach(doc => (result.push({ id: doc.id, ...doc.data() })));
		let sharedRosters = await this.props.firebase.rosters().where('shared_with', 'array-contains', profile.id).get();
	    sharedRosters.forEach(doc => (result.push({ id: doc.id, ...doc.data() })));
		this.setState({ rosters: result })
	};

	handleSelectStudent = async (details, isCheckin = false, selectedItems = []) => {
		const {width, history} = this.props;

		this.setState({
			isLoading: true
		})
	
		
		
		if (width < 700) {
			if (isCheckin === true) {
				localStorage.setItem("mobileProfile", 'true')
			}
			history.push(`/app/profile/${details.id}`)
		} else {
			try {
				//let studentRef = this.props.firebase.student(details.id);
				let leavesRef = await this.props.firebase.leaves().where('student_uid', '==', details.id).orderBy('start_date', 'asc').get();
				let leaveResult = [];
				let waveResult = [];
				//let waveRef = await studentRef.collection('wave_history').orderBy('post_time').get();
				leavesRef.docs.forEach(doc => leaveResult.push({id: doc.id, ...doc.data()}));
				//waveRef.docs.forEach(doc => waveResult.push({id: doc.id, ...doc.data()}));
				/**
				for(let i in waveResult) {
					let creator;
					let studentList = students.filter(student => waveResult[i].creator_uid === student.id);
					if (studentList[0]) {
						creator = {id: studentList[0].id, ...studentList[0]};
					}
					else {
						let creatorRef = await this.props.firebase.faculty(waveResult[i].creator_uid).get();
						creator = {id: creatorRef.id, ...creatorRef.data()};
					}
					waveResult[i].creator = creator;
					
				}
				*/
				

				details.leaves = leaveResult;
				details.wave = waveResult;

				if (isCheckin === true) {
					this.setState({
						checkin: false,
						isCheckin: false,
						draftCheckIn: selectedItems,
						currentStudent: details,
						detailsView: true,
						isLoading: false,
					})
				} else {
					this.setState({
						currentStudent: details,
						detailsView: true,
						isLoading: false,
					});						
				}
			} catch (err) {
				//console.log('failed to fetch student: ', err)
			}
		}


	};

	handleWaveStudents = async (location) => {
		const {detailsView, currentStudent} = this.state;
		const {students, profile, isFaculty} = this.props;
		if (isFaculty) {
			try {
				if (detailsView === true) {
					if (!currentStudent.on_leave) {
						let studentRef = this.props.firebase.student(currentStudent.id);
						let waveRef = studentRef.collection('wave_history');

						let newWave = waveRef.doc();
						newWave.set({
							creator_uid: profile.id,
							location_is_geowave: false,
							location_uid: location,
							post_time: Math.floor(Date.now() / 1000)
						});
						studentRef.update({
							current_location: location
						});
						this.handleStudentSelect(currentStudent)
					}
				} else {
					for (let i in students) {
						if (!students[i].on_leave) {
							let studentRef = this.props.firebase.student(students[i].id);
							let waveRef = studentRef.collection('wave_history');

							let newWave = waveRef.doc();
							newWave.set({
								creator_uid: profile.id,
								location_is_geowave: false,
								location_uid: location,
								post_time: Math.floor(Date.now() / 1000)
							});
							studentRef.update({
								current_location: location
							})
						}
					}
				}

			} catch (err) {
				//console.log(err)
			}
		}
	};

	setPageView = (isColumn) => {
		this.setState({columnView: isColumn})
	};

	toggleDetailsView = () => {
		this.setState({detailsView: !this.state.detailsView})
	};

	updateSearch = (e) => {
		const {updateSearch} = this.props;

		updateSearch(e.target.value)
	};

	componentWillUnmount() {
		// const {clearSearch, clearFilter} = this.props;
		// clearSearch()
		// // clearFilter()
	}

	componentWillReceiveProps(nextProps, nextContext) {
		// console.log('nextProps', nextProps)
		if (nextProps.search !== this.props.search) {
			if (this.state.detailsView === true) {
				this.setState({detailsView: false})

			}
		}
	}

	render() {
		const {columnView, detailsView, wave, rosters} = this.state;

		const { schoolInfo, filters, clearFilter, history} = this.props;

		// Uncomment to run update function
		// if(students.length > 0 && updated === false && updating === false){
		// 	console.log(students.length)
		// 	this.updateStudentFields()
		// }

		let showDetails = columnView;
		if (detailsView) {

			showDetails = true
		}
		if (columnView) {
			showDetails = true
		}

		if (localStorage.getItem("mobileProfile")) {
			return <Loading />;
		}


		return (
			<Box>
 
				<MobileHeader>
					<PageTitle color={'black'} pt={2}>{showDetails ? "Max's Profile" : "Search Students"}</PageTitle>
					<ApplyFilter
						school={schoolInfo}
						filters={JSON.parse(JSON.stringify(filters))}
						clearFilter={clearFilter}
						rosters={rosters}
						history={history}
						handleDeleteRoster={this.handleDeleteRoster}
						{...this.props}
					/>
					{/*<PageSubTitle>0 Students selected</PageSubTitle>*/}
				</MobileHeader>


				{/* Mobile Search Input */}
				<Box ml={[0, '50%', '70%']}>
					<MobileBox>
						<PositionBox position={'fixed'} top={'114px'} width={1} zIndex={9999}>
							{/*s*/}

							<SearchInput/>
						</PositionBox>

					</MobileBox>

				</Box>

				<Content>

					{/* Checkin and Wave popups */}

					<WavePopup visible={wave} toggle={() => this.setState({wave: false})}
					           handleConfirm={this.handleWaveStudents}/>

					{/* Student Summary Section for Desktop*/}

					{this.renderStudentSummary()}

					{this.renderCheckins()}

					<ConfirmDelete
						visible={this.state.confirmDelete}
						toggle={() => this.setState({ confirmDelete: false, deleteRosterData: {} })}
						handleConfirm={this.confirmDeleteRoster}
					/>
				</Content>
			</Box>
		)
	}

	// ----------------------------
	// CHECKIN Functions and Renders
	// ----------------------------

	fetchRecentCheckin = async () => {
		const {profile, isFaculty, firebase} = this.props;
		if (isFaculty) {
			try {
				let checkinRef = await firebase.checkins().where('type', '==', 0).where('creator_uid', '==', profile.id).where('active', '==', true).orderBy('created_at', 'desc').limit(1).get();
				let dormCheckinRef = await firebase.checkins().where('type', '>', 1).where('creator_uid', '==', profile.id).where('active', '==', true).orderBy('type', 'desc').orderBy('created_at', 'desc').limit(1).get();

				let result = [];
				let dormResult = []
				checkinRef.docs.forEach(doc => result.push({id: doc.id, ...doc.data()}));
				dormCheckinRef.docs.forEach(doc => dormResult.push({id: doc.id, ...doc.data()}));
				if (result.length > 0) {
					if (localStorage.getItem("mobileProfile")) {
						localStorage.removeItem("mobileProfile");
						this.setState({
							openRecentCheckin: true,
							checkin: false
						});
					}
					if(dormResult.length > 0){
						if(dormResult[0].created_at < result[0].created_at) {
							this.setState({recentCheckin: result[0]})

						} else {
							this.setState({recentCheckin: dormResult[0]})
						}
					} else {
						this.setState({recentCheckin: result[0]})
					}
				}
			} catch (e) {
				//console.log("Error saving checkin: ", e)
			}
		}
	};


	handleSaveCheckin = async (selected, log = '', all) => {
		const {profile, isFaculty, firebase, filters, rosterFilter} = this.props;
		if (isFaculty) {
			try {

				let newCheckinRef = firebase.checkins().doc();
				// const filteredIdList = students.map(student => student.id)

				let type = 0;
				let type_id = 'GENERAL'
				if(filters.dorm.length === 1){
					type = 3
					type_id = filters.dorm[0]
				}
				// if(filters.d)
				await newCheckinRef.set({
					creator_uid: profile.id,
					is_faculty: isFaculty,
					all,
					present: selected,
					type,
					type_id,
					duty_log: log,
					filters: filters,
					rosterFilter: rosterFilter,
					active: true,
					live: false,
					created_at: Math.floor(Date.now() / 1000),
					updated_at: Math.floor(Date.now() / 1000)
				})
				let newCheckin = await newCheckinRef.get();
				//console.log('newCheckin Saved: ', newCheckin);
				this.setState({recentCheckin: {id: newCheckin.id, ...newCheckin.data()}})
				return newCheckinRef.id
			} catch (e) {
				//console.log("Error saving checkin: ", e)
				return false
			}
		}
	};

	handleCheckinDiscard = () => {
		// const {clearFilter} = this.props;
		// clearFilter()
		this.setState({recentCheckin: null, openRecentCheckin: false, checkin: false})
	};

	handleUpdateCheckin = async (selected) => {
		const {isFaculty, firebase} = this.props;

		const {recentCheckin} = this.state;
		if (isFaculty) {
			try {
				let checkinRef = firebase.checkins().doc(recentCheckin.id);

				checkinRef.update({
					present: selected,
					updated_at: Math.floor(Date.now() / 1000)
				});
				let newCheckin = await checkinRef.get();
				this.setState({recentCheckin: {id: newCheckin.id, ...newCheckin.data()}})
				return true
			} catch (e) {
				//console.log("Error saving checkin: ", e)
				return false
			}
		}
	};

	toggleRecentCheckin = () => {
		const {recentCheckin, openRecentCheckin} = this.state;
		if (openRecentCheckin === false) {
			if (recentCheckin && recentCheckin.filters) {
				// updateFilter(recentCheckin.filters)
				this.setState({openRecentCheckin: true})
			}
		} else {
			this.setState({openRecentCheckin: false})
		}
	}

	returnCheckinTitle = async (checkin, school) => {
		const {firebase} = this.props;
		let result = ''
		if(checkin.type === 0){
			result = returnFilterString(checkin.filters, school)
		}
		if(checkin.type === 1){
			const roster = await firebase.roster(checkin.type_id).get()
			const data = roster.data()
			result = data.name
		}
		if(checkin.type === 3){
			let dorm = school.subDormMap[checkin.item_id]
			if(dorm){
				result = dorm.name
			}
		}
		return result
	}

	renderCheckins = () => {
		const { openRecentCheckin, checkin, recentCheckin, isCheckin, draftCheckIn, isLoading, detailsView, rosters } = this.state;

		const { students, allStudents, history, isFaculty} = this.props;

		let recentStudents = []
		if(recentCheckin !== null && recentCheckin.all){
			recentStudents = allStudents.filter(student => recentCheckin.all.includes(student.id))
		}
 
		return (
			<Fragment>
				{(checkin && !isLoading) &&
				<Checkin visible={checkin} handleSave={this.handleSaveCheckin}
						 toggleVisible={() => this.setState({checkin: false})}
						 students={students} title={'New Checkin'}
						 handleDiscard={this.handleCheckinDiscard}
						 handleSelectStudent={this.handleSelectStudent}
						 draftSelected={isCheckin ? draftCheckIn : []}
						 rosters={rosters} history={history}
						 isFaculty={isFaculty}
						 />}
				{recentCheckin !== null && openRecentCheckin &&
				<Checkin visible={openRecentCheckin} handleSave={this.handleUpdateCheckin}
						 handleDiscard={this.handleCheckinDiscard}
						 handleSelectStudent={this.handleSelectStudent}
						 draftSelected={isCheckin ? draftCheckIn : []}
				         toggleVisible={this.toggleRecentCheckin} students={recentStudents} 
						 previous={recentCheckin} title={'Recent Checkin'}
						 rosters={rosters} history={history}
						 isFaculty={isFaculty}
						/>}
				{recentCheckin !== null && !detailsView &&
				<ResumeCheckin toggleRecentCheckin={this.toggleRecentCheckin} checkin={recentCheckin}/>
				}
			</Fragment>

		)
	}

	toggleConfirmCheckIn = () => {
		this.setState({
			toggleConfirmCheckIn: !this.state.toggleConfirmCheckIn,
			checkin: true,
			newCheckinFilters: this.props.filters,
			newCheckinRosterFilter: this.props.rosterFilter
		});
	}

	handleDeleteRoster = data => {
		this.setState({
			confirmDelete: true,
			deleteRosterData: data
		});
	};

	confirmDeleteRoster = () => {
		const data = this.state.deleteRosterData;
		const { profile, isFaculty, firebase, history } = this.props;
		if (isFaculty && profile.id === data.creator_uid) {
			firebase.chat(data.chat_uid).delete().then(() => console.log('Roster chat deleted succesfully')).catch(error => console.log("Error removing document: ", error));
			firebase.roster(data.id).delete().then(() => {
				history.replace('/app/search');
				history.push('/app/search');
				this.setState({ confirmDelete: false, deleteRosterData: {} });
			})
				.catch(error => console.log("Error removing document: ", error))
		}
	};

	newFilterTitle = title => {
		const { rosterFilter } = this.props;
		let newText = '';
		rosterFilter.forEach(obj => {
			newText = newText + ', ' + obj.name + '-roster';
		});
		if (newText === ', ' || newText === '') {
			return title;
		} else {
			if (title === 'All Students') {
				return newText.substr(2);
			} else {
				return title + newText;
			}
		}
	}

	handleChatRedirect = async () => {
		const { school, filters, history, width, updateCurrentChat, firebase, profile, search, students } = this.props;
		let filterTitle = returnFilterString(filters, school);

		if (this.newFilterTitle(filterTitle) !== 'All Students') {
			let newTitle = this.newFilterTitle(filterTitle).replace(/\s+/g, "").toLowerCase();
			let sortedTitle = newTitle.split(',').sort().join(',').replace(/[(),/]/g, "");
			let studentList = filterStudentsByName(this.filteredByRoster(students), search);
			let studentArr = [profile.id];

			let chatTitle = this.newFilterTitle(filterTitle).replace(/-roster/g, '');
			
			studentList.forEach(obj => {
				studentArr.push(obj.id);
			});

			try {
				let chatsRef = await firebase.chats().where('custom_id', '==', sortedTitle).get();
				let chatId;
				if (chatsRef.docs.length === 0) {
					const newRosterChat = await firebase.chats().add({
						creator_uid: profile.id,
						is_group: true,
						name: chatTitle,
						members: studentArr,
						post_time: Math.floor(Date.now() / 1000),
						last_updated: Math.floor(Date.now() / 1000),
						messages: [],
						accepted: { status: 1, updated_at: Math.floor(Date.now() / 1000), members: studentArr },
						custom_id: sortedTitle
					});
					chatId = newRosterChat.id;
				} else {
					chatId = chatsRef.docs[0].id;
				}
				if (width < 700) {
					history.push(`/app/chat/${chatId}`);
				} else {
					updateCurrentChat(chatId);
					history.push(`/app/chat`)
				}
			} catch (e) {
				//console.log('chat redirect failed', e)
			}
		} else {
			history.push('/app/chat');
		}
	};

	filteredByRoster = students => {
		const { rosterFilter } = this.props;
		let newData = [];
		rosterFilter.forEach(obj => {
			newData.push(...obj.students_uid);
		});

		let rosterStudentId = uniq(newData);

		if (rosterStudentId.length === 0) {
			return students
		} else {
			return students.filter(obj => rosterStudentId.includes(obj.id))
		}
	}

	renderStudentSummary = () => {
		const {currentStudent, columnView, detailsView, toggleConfirmCheckIn, isLoading, rosters, locationSearch} = this.state;
		const {width, loading, students, search, profile, schoolInfo, filters, clearFilter, history} = this.props;

		let listProps = {
			width: [1, 1 / 4],
			mt: [0, 0],
		};

		if (!columnView) {
			listProps = {
				width: 1,
				mt: [0, 3]
			}
		}

		let showUserList = true;
		let showToolbar = true;
		let showDetails = columnView;
		if (detailsView) {
			showToolbar = false;
			showUserList = false;
			showDetails = true
		}
		if (columnView) {
			showToolbar = true;
			showUserList = true;
			showDetails = true
		}
		const showSummary = (width > 700 && showDetails);

		// let searchList = filterStudentsByName(students, search);
		let searchList = filterStudentsByName(this.filteredByRoster(students), search);
		return (
			<Fragment>
				{this.renderFabButton()}
 
				{toggleConfirmCheckIn ? <ConfirmCheckIn toggle={this.toggleConfirmCheckIn}/> : null }


				{/* DESKTOP Toolbar with Filters and Column/Grid View*/}
				<DesktopBox>
					{showToolbar &&
					<Toolbar p={2} bg={'white'} boxShadow={['none', 'main']}>

						<Box css={{display: 'inline-block'}} ml={5}><Text fontSize={0} fontWeight={700} py={2} mt={'3px'}
						                                                  color={'meta'}>VIEW</Text></Box>
						<Box bg={'transparent'} ml={3} py={2}
						     onClick={() => this.setState({columnView: false, detailsView: false})}>
							<GridIcon color={!columnView ? 'black' : '#969a9b'}/>
						</Box>
						<Box ml={2} py={2} onClick={() => this.setState({columnView: true})}>
							<ColumnIcon color={columnView ? '#00000' : '#969a9b'}/>
						</Box>

						<Box css={{display: 'inline-block'}} ml={5}><Text fontSize={0} fontWeight={700} py={2} mt={'3px'}
						                                                  color={'meta'}>FILTER</Text></Box>
						<Box ml={3}>
							<FilterDropdown
								width={width}
								school={schoolInfo}
								filters={JSON.parse(JSON.stringify(filters))}
								clearFilter={clearFilter}
								rosters={rosters}
								history={history}
								handleDeleteRoster={this.handleDeleteRoster}
								locationInfo={locationSearch !== '' ? locationSearch : []}
							/>
						
						</Box>
					</Toolbar>
					}
				</DesktopBox>

				{(loading || isLoading || localStorage.getItem("mobileProfile")) ? <Loading/> :

					<Flex width={1}>
						{showUserList &&
						<SidebarBox {...listProps} css={{minWidth: '260px'}}>
							<SidebarWrapper boxShadow={['none', columnView ? 'inset' : 'none']} pb={[50, 0]} pt={[0, '10px']}>
								<UserList students={searchList} handleUserClick={this.handleSelectStudent} withLocation
								          columnView={columnView} current={currentStudent ? currentStudent.id : '1'} infiteScroll/>
							</SidebarWrapper>
						</SidebarBox>}
						{showSummary ?

							<StudentSummary student={currentStudent} showBack={!showToolbar} isFaculty={true}
							                handleBack={() => {
												if(!this.state.isCheckin) {
													this.setState({
														detailsView: false,
														openRecentCheckin: true,
														isCheckin: true
													})
												}
												this.setState({detailsView: false})
											}} profile={profile}/>
							: <Box/>
						}

					</Flex>}

			</Fragment>
		)
	}

	renderFabButton = () => {
		const { columnView, detailsView} = this.state;

		const {width, filters, rosterFilter} = this.props;




		let showDetails = columnView;
		if (detailsView) {

			showDetails = true
		}
		if (columnView) {

			showDetails = true
		}
		const showSummary = (width > 700 && showDetails);


		let showFab = true
		if(!columnView && showSummary){
			showFab = false
		}

		return (
			<Fragment>
				{showFab &&

					<Fab
						mainButtonStyles={{marginBottom: '50px', backgroundColor: '#FFC61A', width: '47px', height: '47px'}}
						icon={<AutoFocusInside><MdAdd color={'white'}/></AutoFocusInside>}
						event={'click'}
						actionButtonStyles={{color: 'black'}}
					>
						<Action
							text='Check In'
							onClick={() => {
								if (!localStorage.getItem('isCheckedIn')) {
									localStorage.setItem("isCheckedIn", 'true')
									this.setState({
										toggleConfirmCheckIn: true
									})
								} else {
									this.setState({
										checkin: true,
										newCheckinFilters: filters,
										newCheckinRosterFilter: rosterFilter
									})
								}
							}}
						>
							<Check/>
						</Action>
						<Action
							text='Chat'
							onClick={this.handleChatRedirect}
						>
							<Chat/>
						</Action>
					</Fab>}
			</Fragment>
		)
	}
}



export default withRouter(Search)

// updateStudentFields = async () => {
// 	this.setState({updating: true})
// 	const {students, schoolInfo} = this.props;
// 	let noDorm = []
// 	const subDorms = schoolInfo.subDormMap
//
// 	try {
// 		for (let i in students) {
// 			let student = students[i]
// 			if (!student.sub_dorm) {
// 				noDorm.push(student)
// 				console.log(student.dorm)
// 				console.log(subDorms[student.dorm])
// 				// let result = await this.updateStudentDorms(student)
//
// 			}
// 		}
// 		console.log(noDorm.length)
// 	} catch (err) {
// 		console.log('Failed updating student', err)
// 	}
//
// 	this.setState({updated: true, updating: false})
// }
//
// updateStudentDorms = async (student) => {
// 	const {schoolInfo} = this.props;
// 	const subDorms = schoolInfo.subDormMap
// 	try {
// 		let studentRef = this.props.firebase.student(student.id)
// 		const subDormID = student.dorm
//
// 		// let dormId = student.dorm
//
// 		const subDorm = subDorms[subDormID]
// 		if (subDorm === undefined) {
//
// 		}
// 		if (subDorm && subDorm.dorm_id) {
// 			const dormId = subDorm.dorm_id
// 			console.log(student.id, dormId, subDormID)
//
// 			// console.log(newData)
// 			studentRef.update({
// 				dorm: dormId,
// 				sub_dorm: subDormID
// 			})
// 		}
// 		// console.log(dormId)
//
// 	} catch (e) {
// 		console.log(e)
// 	}
//
// 	return true
// }